var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWorkcanvasColored = function SvgWorkcanvasColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10556_100)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.936 1.953h16.128v16.282H1.936z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#113357",
    fillRule: "evenodd",
    d: "M17.195 2.831H2.805v14.526h14.39zM1.936 1.953v16.282h16.128V1.953z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.484 0H20v4.559h-4.516z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#113357",
    fillRule: "evenodd",
    d: "M19.13.878h-2.776V3.68h2.776zM15.484 0v4.559H20V0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h4.516v4.559H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#113357",
    fillRule: "evenodd",
    d: "M3.646.878H.87V3.68h2.776zM0 0v4.559h4.516V0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.484 15.441H20V20h-4.516z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#113357",
    fillRule: "evenodd",
    d: "M19.13 16.319h-2.776v2.803h2.776zm-3.646-.878V20H20v-4.559z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 15.441h4.516V20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#113357",
    fillRule: "evenodd",
    d: "M3.646 16.319H.87v2.803h2.776zM0 15.44V20h4.516v-4.559z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#113357",
    d: "M10.208 14.694q-1.111 0-1.94-.363a4 4 0 0 1-1.362-1.011 4.2 4.2 0 0 1-.814-1.422 5.3 5.3 0 0 1-.266-1.66v-.3q0-.885.282-1.69a4.4 4.4 0 0 1 .83-1.454 3.85 3.85 0 0 1 1.36-.995q.83-.363 1.895-.363 1.158 0 2.05.458.893.442 1.424 1.248.532.805.595 1.849h-2.457a1.55 1.55 0 0 0-.47-.98q-.391-.41-1.142-.41-.626 0-1.05.315-.405.315-.61.87-.203.552-.203 1.31 0 .695.188 1.265a1.8 1.8 0 0 0 .595.869q.422.3 1.095.3.501 0 .845-.174.36-.19.564-.506a1.7 1.7 0 0 0 .266-.758h2.442q-.048 1.074-.595 1.896a3.8 3.8 0 0 1-1.456 1.264q-.908.442-2.066.442"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10556_100"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgWorkcanvasColored;